<!--
 * @Author: your name
 * @Date: 2021-03-11 16:02:40
 * @LastEditTime: 2021-08-09 15:36:27
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \mooklook_phone\src\views\StarItem.vue
-->
<template>
  <div class="mook_starItem">
    <div :style="{ minHeight: height + 'px' }">
      <div class="goods_detail" v-if="starItemData">
        <div class="goods_img bg_img" :style="{backgroundImage:'url('+(starItemData.imageUrls&&starItemData.imageUrls[0]?starItemData.imageUrls[0].imageUrl:starItemData.imageUrl)+')'}">
          <!-- <img
            class="auto-img"
            :src="isDetail?starItemData &&starItemData.imageUrls[0]&& starItemData.imageUrls[0].imageUrl:starItemData.imageUrl"
          /> -->
        </div>
        <div class="detail">
          <div class="title">{{ starItemData.subTitle }}</div>
          <div class="vice_title">{{ starItemData.title }}</div>
          <div class="price" v-if="starItemData.price">
            {{ starItemData.price }}{{ lange == "Ch" ? "元" : "円" }}
          </div>
          <div class="understand">
            <div class="txt">{{lange=='Ch'?'了解详情':'詳細を知る'}}</div>
            <div
              class="icon"
              @click="openIcon"
              :style="'transform: rotate(' + rotate + 'deg)'"
            >
              <img class="auto-img" src="@/assets/icon/open.png" />
            </div>
          </div>
          <div class="content" :style="'height:' + contentH">
            {{ starItemData.description }}
          </div>
        </div>
      </div>
      <div class="detail_img" v-if="starItemData"  v-html="isDetail?starItemData.content:starItemData.productContent"></div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
import { carouselByTitle, getClassifyList, getProductDetaile } from "@/api/api";
import Footer from "../components/Footer";
export default {
  components: { Footer },
  // 定义属性
  data() {
    return {
      isPhone: document.body.clientWidth < 920,
      height: 0,
      detail: "",
      video: [],
      poster: [],
      rotate: 0,
      starItemData: null,
      contentH: "auto",
    };
  },
  // 计算属性，会监听依赖属性值随之变化
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    getCarouselByTitle(type) {
      let title = type ? this.detail.title : this.detail.title + "(视频)";
      let params = {
        title: title || "",
      };
      carouselByTitle(params)
        .then((res) => {
          if (res.data.code == 0) {
            this.video = res.data.data;
            if (type) {
              this.porductPoster = this.video;
            } else {
              if (this.video.length > 0)
                this.playerOptions.sources[0].src = this.video[0]
                  ? this.video[0].imageUrl
                  : "";
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    openIcon() {
      this.rotate = this.rotate == 0 ? 180 : 0;
      this.contentH = this.rotate == 180 ? "50px" : "auto";
    },
    getProductDetaile() {
      let params = {
        productCategoryId: this.articleId,
        pageIndex: 1,
        pageSize: 1,
      };
      if (this.isDetail) {
        getProductDetaile(this.articleId).then((res) => {
          if (res.data.code == 0) {
            this.starItemData = res.data.data;
          }
        });
      } else {
        getClassifyList(params).then((res) => {
          if (res.data.code == 0) {
            let starItemData=res.data.data.data.length > 0 ? res.data.data.data[0] : "";
              if(starItemData && starItemData.productImageList && starItemData.productImageList.length>0){
                starItemData.imageUrls=[{imageUrl:starItemData.productImageList[0]}]
              }
            this.starItemData =starItemData;
              
          }
        });
      }
    },
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
    if (this.$route.query.detail) {
      this.articleId = this.$route.query.id;
      this.isDetail = this.$route.query.isDetail;
      this.detail =
        this.$route.query.detail && JSON.parse(this.$route.query.detail);
      this.poster = [{ imageUrl: this.detail.imageUrl }];
      this.getCarouselByTitle();
      this.getCarouselByTitle("poster");
      this.getProductDetaile();
    }
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    let height = this.isPhone ? 233 : 427;
    this.height = window.screen.availHeight - height;
  },
  watch: {
    $route(to) {
      if (to.path == "/starItem" && to.query.detail) {
        this.articleId = to.query.id;
        this.isDetail = to.query.isDetail;
        this.detail = to.query.detail && JSON.parse(to.query.detail);

        this.poster = [{ imageUrl: this.detail.imageUrl }];
        this.getCarouselByTitle();
        this.getCarouselByTitle("poster");
        this.getProductDetaile();
      }
    },
  },
};
</script>

<style lang='less' scoped>
.mook_starItem {
  .goods_detail {
    max-width: 1440px;
    min-width: 1240px;
    margin: 0 auto 80px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .goods_img {
      width: 600px;
      height: 600px;
      // height: 900px;
      overflow: hidden;
    }
    .detail {
      width: calc(100% - 898px);
      padding: 0 189px 0 30px;
      // padding: 0 149px;
      .title {
        font-size: 24px;
        font-weight: 400;
        color: #212121;
        margin-bottom: 19px;
        // margin-top: 268px;
      }
      .vice_title {
        font-size: 26px;
        font-weight: 400;
        color: #212121;
        margin-bottom: 30px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
          background-image:linear-gradient(0deg,#eed593 45%,#fff 0);
      }
      .price {
        font-size: 20px;
        font-weight: bold;
        color: #876d4b;
        padding: 29px 0;
        border-top: 1px solid #878787;
        border-bottom: 1px solid #878787;
        margin-bottom: 30px;
      }
      .understand {
        display: flex;
        justify-content: space-between;
        font-size: 18px;
        font-family: Microsoft YaHei;
        color: #212121;
        font-weight: bold;
        margin-bottom: 26px;
        .icon {
          width: 18px;
          height: 18px;
          margin-top: 5px;
          cursor: pointer;
        }
      }
      .content {
        font-size: 16px;
        font-weight: 400;
        color: #878787;
        overflow: hidden;
      }
    }
  }
  .detail_img {
    width: 1200px;
    margin: 0 auto 80px;
  }
}
</style>
